// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1A5df","log":"ModalInventoryLogs_log__2IgXg","date":"ModalInventoryLogs_date__2FbP9","userName":"ModalInventoryLogs_userName__2ze9L"};